import React from "react";
import { Heart } from "lucide-react";
import SacredChatPage from "./SacredChatPage";
import { PLAYLISTS } from "@/lib/tracks";

const LESSON_TOPICS = {
  fr: [
    "Éros (passion grecque)",
    "Philia (amitié profonde)",
    "Storgé (tendresse familiale)",
    "Agapè (amour universel)",
    "Diotime et le Banquet",
    "L'échelle de l'amour (Platon)",
    "Éros et Psyché (mythe)",
    "Sappho — fragment 31",
    "Phèdre : les 4 délires (Platon)",
    "Attachement vs amour",
    "Hésiode — Éros primordial",
    "Aphrodite et les 3 Grâces",
  ],
  en: [
    "Eros (Greek passion)",
    "Philia (deep friendship)",
    "Storge (familial tenderness)",
    "Agape (universal love)",
    "Diotima and the Symposium",
    "The ladder of love (Plato)",
    "Eros and Psyche (myth)",
    "Sappho — fragment 31",
    "Phaedrus: the 4 divine madnesses",
    "Attachment vs love",
    "Hesiod — primordial Eros",
    "Aphrodite and the 3 Graces",
  ],
};

export default function Eros() {
  return (
    <SacredChatPage
      persona="eros"
      personaLabel="Éros"
      IconComponent={Heart}
      accent="#ff6b9d"
      theme={{
        bgRadial: "radial-gradient(ellipse at top, #2a0a1c 0%, #1a040e 55%, #080206 100%)",
        fg: "#ffe0ec",
        msgBg: "linear-gradient(180deg, rgba(40,10,28,0.92), rgba(12,2,8,0.95))",
        msgFg: "#f5b8ce",
      }}
      title={{
        fr: <><span className="italic" style={{ color: "#ff6b9d" }}>Éros</span>, éducateur à l'amour.</>,
        en: <><span className="italic" style={{ color: "#ff6b9d" }}>Eros</span>, teacher of love.</>,
      }}
      subtitle={{
        fr: "🏹 Dieu primordial de l'Amour (Théogonie d'Hésiode). Je t'enseigne les 4 formes d'amour grecques — Éros, Philia, Storgé, Agapè — comme un sage doux qui éclaire sans écraser. Pas de recette magique : l'amour s'apprend par l'expérience.",
        en: "🏹 Primordial god of Love (Hesiod's Theogony). I teach you the 4 Greek forms of love — Eros, Philia, Storge, Agape — as a gentle sage who illuminates without crushing. No magic recipe: love is learned through experience.",
      }}
      greeting={{
        fr: "« Dis-moi, cœur d'ami·e, où palpite ta question d'amour aujourd'hui ? »",
        en: "\"Tell me, dear heart, where does your question of love beat today?\"",
      }}
      suggestions={{
        fr: [
          "Mon ex me manque, comment apaiser mon cœur ?",
          "Quelle différence entre attachement et amour ?",
          "Comment aimer sans me perdre ?",
          "Explique-moi l'allégorie d'Éros et Psyché.",
        ],
        en: [
          "I miss my ex, how to soothe my heart?",
          "What's the difference between attachment and love?",
          "How to love without losing myself?",
          "Explain the allegory of Eros and Psyche.",
        ],
      }}
      playlist={PLAYLISTS.eros}
      lessonMode={{
        endpoint: "/chat/eros/lesson",
        title: {
          fr: "Choisis un thème d'amour",
          en: "Pick a love topic",
        },
        topics: LESSON_TOPICS,
      }}
    />
  );
}
